import { DBDef_DiseaseProfile, DBDef_DiseaseValue, DBDef_DiseaseView, DBDef_MultiVar, } from '@app/dp-shared';
import { ModuleFE_DiseaseProfile, ModuleFE_DiseaseView, ModuleFE_MultiVar } from '../_entity.js';
import { ConfigKeyFE_DiseasesViewsTagId, ModuleFE_Variable } from '@app/hcs-frontend';
const conflictResolutionItem_DiseaseProfile = {
    dbKey: DBDef_DiseaseProfile.dbKey,
    collectionRenderer: () => 'Disease Profiles',
    renderer: dp => dp.label,
    filterMapper: dp => [dp.label]
};
const conflictResolutionItem_MultiVar = {
    dbKey: DBDef_MultiVar.dbKey,
    collectionRenderer: () => 'Multi Vars',
    renderer: mv => {
        const dp = ModuleFE_DiseaseProfile.cache.unique(mv.diseaseProfileId);
        const dvTagId = ConfigKeyFE_DiseasesViewsTagId.get();
        const dvTagGroup = mv.variables[0]?.tagIds.find(group => group.key === dvTagId);
        const dv = dvTagGroup?.value[0] ? ModuleFE_DiseaseView.cache.find(dv => dv.enforcedTags.includes(dvTagGroup?.value[0])) : undefined;
        const firstVar = ModuleFE_Variable.cache.unique(mv._firstVarId);
        if (!dp || !dv || !firstVar)
            return;
        return `${dp.label} > ${dv.label} > ${firstVar.name}`;
    },
    filterMapper: mv => {
        const firstVar = ModuleFE_Variable.cache.unique(mv._firstVarId);
        if (!firstVar)
            return [];
        return [firstVar._nameInLowercase];
    }
};
const conflictResolutionItem_DiseaseValue = {
    dbKey: DBDef_DiseaseValue.dbKey,
    collectionRenderer: () => 'Disease Values',
    renderer: dv => {
        const mv = ModuleFE_MultiVar.cache.unique(dv.multiVarId);
        if (!mv)
            return;
        return conflictResolutionItem_MultiVar.renderer(mv);
    },
    filterMapper: () => [],
};
const conflictResolutionItem_DiseaseView = {
    dbKey: DBDef_DiseaseView.dbKey,
    collectionRenderer: () => 'Disease Views',
    renderer: dv => dv.label,
    filterMapper: dv => [dv.label],
};
export const ConflictResolutionItemGroup_DP = [
    conflictResolutionItem_DiseaseProfile,
    conflictResolutionItem_MultiVar,
    conflictResolutionItem_DiseaseValue,
    conflictResolutionItem_DiseaseView,
];
//# sourceMappingURL=conflict-resolution-items.js.map